import { Image } from 'react-datocms';
import { CdaStructuredTextRecord } from 'react-datocms/structured-text';
import { Person } from '@carbonify/ui';
import clsx from 'clsx';
import CtaButton from 'components/CtaButton';
import { ResponsiveImage } from 'services/graphql';

import styles from './AuthorBlock.module.css';

interface AuthorBlockRecord extends CdaStructuredTextRecord {
  image?: ResponsiveImage | null;
  title: string;
  subtitle?: string;
  cta?: string;
  withMargins?: boolean;
}

export default function AuthorBlock({ title, subtitle, image, cta, withMargins }: AuthorBlockRecord) {
  return (
    <Person
      image={
        image && (
          // eslint-disable-next-line jsx-a11y/alt-text
          <Image
            data={image.responsiveImage}
            objectFit="cover"
            objectPosition="center"
          />
        )
      }
      title={title}
      subtitle={subtitle}
      cta={cta && <CtaButton>{cta}</CtaButton>}
      itemProp="author"
      className={clsx(withMargins && styles.container)}
      size={withMargins ? 'md' : 'sm'}
    />
  );
}
